import { CASES } from './constants';

export const updateJobMetrics = (payload) => {
    return { type: CASES.UPDATE_JOB_METRICS, payload };
};

export const updateJobMetricsForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_JOB_METRICS_FORM,
        payload: { key, data },
    };
};

export const clearJobMetrics = () => {
    return { type: CASES.CLEAR_JOB_METRICS, payload: {} };
};
